var _path, _path2;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMoonGimp = function SvgMoonGimp(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 512 512",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.45 66.312A222.04 222.04 0 0 0 9.01 287.022a222.04 222.04 0 0 0 222.04 222.04 222.04 222.04 0 0 0 220.76-204.18 172.19 172.19 0 0 1-142.01 75.289 172.19 172.19 0 0 1-172.19-172.19 172.19 172.19 0 0 1 74.834-141.67z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m246.23 213.28 25.32-77.011-66.331-46.605 81.066.284 23.826-77.486 24.781 77.186 81.056-1.285-65.75 47.42 26.269 76.692-65.417-47.879zM400.56 306.1l13.746-39.553-33.833-24.673 41.865.851 13.01-39.802 12.128 40.079 41.874.074-34.37 23.919 12.87 39.847-33.37-25.296z"
  })));
};
export default SvgMoonGimp;